import AddModal from './AddModal';

export default AddModal;
